var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArWayPrimaryLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 64,
    viewBox: "0 0 72 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0944 12.5221C44.4139 10.6453 40.246 9.62164 35.8587 9.62164C31.447 9.62164 27.3034 10.6697 23.6229 12.5221L28.3515 4.33248C31.6907 -1.44416 40.0266 -1.44416 43.3659 4.33248L48.0944 12.5221Z",
    fill: "url(#paint0_linear_239_42235)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6159 50.9843L63.0356 37.8467L54.8459 23.6855C54.4559 23.0274 54.0416 22.4424 53.5297 21.9549C51.4336 19.81 48.4356 18.9813 45.6813 19.5175C43.3658 19.9806 41.1965 21.3455 39.8559 23.6855L39.1734 24.8554L36.0048 30.3396L44.2676 44.6471L47.9481 51.0087C51.2873 56.7853 47.1194 64 40.4409 64H63.0356H63.1087C69.7628 63.9757 73.9308 56.761 70.6159 50.9843Z",
    fill: "url(#paint1_linear_239_42235)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0356 36.7986V37.871L54.8459 23.7097C54.7972 23.6366 54.7484 23.5635 54.6997 23.4904C54.3584 22.9298 53.9685 22.4179 53.5297 21.9792C49.6786 18.0062 42.7808 18.5912 39.8315 23.7097L36.0048 30.3151L29.0826 42.2827L27.742 44.6226H20.0886C15.6038 44.6226 12.2402 41.3565 11.5333 37.4567C11.2165 35.7261 11.4115 33.8737 12.2889 32.1432C12.3133 32.0944 12.3377 32.0457 12.3621 31.9725C12.4108 31.8507 12.4839 31.7288 12.557 31.6069L13.2883 30.3395L23.5741 12.5221C27.2546 10.6453 31.4225 9.62158 35.8098 9.62158C40.2215 9.62158 44.3651 10.6697 48.0456 12.5221C50.6292 13.8383 52.9935 15.5445 55.0165 17.5675C55.2603 17.8112 55.504 18.055 55.7478 18.3231C60.1838 23.1004 62.9137 29.4864 62.9868 36.4817C63.0356 36.5792 63.0356 36.7011 63.0356 36.7986ZM8.6572 36.7986V38.4316L1.39376 50.9843C-1.89673 56.6878 2.12497 63.805 8.6572 63.9756C8.73033 63.9756 8.82782 63.9756 8.90094 63.9756H36.6873V63.9512H36.0048C20.9661 63.9756 8.7547 51.813 8.6572 36.7986Z",
    fill: "url(#paint2_linear_239_42235)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.441 63.9757H38.6617V63.9513H36.0049C20.9661 63.9513 8.75475 51.7887 8.65726 36.7743V36.6037C8.65726 35.7019 8.70601 34.8244 8.80351 33.9713C9.7541 24.6604 15.4332 16.7389 23.3792 12.6197C23.4523 12.5953 23.5254 12.5466 23.5985 12.4978L13.3127 30.3152L12.5815 31.5826C12.5084 31.7045 12.4352 31.8264 12.3865 31.9482C12.3621 32.0214 12.3377 32.0701 12.3134 32.1189C12.0209 32.7282 11.8015 33.3376 11.6553 33.9713C10.4366 39.1873 14.3364 44.6227 20.113 44.6227H44.292L47.9725 50.9843C51.263 56.761 47.0951 63.9757 40.441 63.9757Z",
    fill: "url(#paint3_linear_239_42235)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.3127 30.3397C11.2653 35.9945 15.4089 42.283 21.7217 42.283H29.0827L27.7421 44.6229H20.0887C13.6052 44.6229 9.48597 37.8225 12.289 32.1434C12.3134 32.0947 12.3377 32.0459 12.3621 31.9728C12.4109 31.8509 12.484 31.729 12.5571 31.6072L13.3127 30.3397Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.9039 44.6228H44.2675L47.948 50.9844C51.2872 56.7611 47.1193 63.9758 40.4408 63.9758H37.0772C43.7557 63.9758 47.9236 56.7611 44.5844 50.9844L40.9039 44.6228Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.5297 21.9548C53.9685 22.3936 54.3584 22.9054 54.6997 23.466C50.5561 20.273 44.1457 21.1505 41.2696 26.1472L37.4185 32.8013L36.0048 30.3395L39.8315 23.7098C42.7808 18.5669 49.6786 17.9819 53.5297 21.9548Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_42235",
    x1: 48.8013,
    y1: 22.418,
    x2: 47.6178,
    y2: 5.33255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9803E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA2069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_239_42235",
    x1: 66.8379,
    y1: 64.0975,
    x2: 32.7572,
    y2: 51.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54E70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_239_42235",
    x1: 63.1596,
    y1: -3.93358,
    x2: 11.822,
    y2: 71.3896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_239_42235",
    x1: 8.65787,
    y1: 38.2535,
    x2: 49.1118,
    y2: 38.2535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67F3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F6EEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArWayPrimaryLogo);
export default __webpack_public_path__ + "static/media/ARWay_Primary_Logo.adc77e3912d317142f19530a26b19cc9.svg";
export { ForwardRef as ReactComponent };